<template>
  <div class="keyan">
    <Banner :banner="banner" />
    <TypeMenu :menu="type" class="type" />
    <transition  name="fade" mode="out-in">
      <component :is="component" />
    </transition>
  </div>
</template>

<script>
import Banner from '@/components/Banner.vue'
import TypeMenu from '@/components/TypeMenu.vue'
import Research from './Research/Research.vue'
import Equipment from './Equipment/Equipment.vue'
import Quality from './Quality/Quality.vue'
import Production from './Production/Production.vue'
import Scrollbar from 'smooth-scrollbar';
import i18n from '@/plugins/i18n.js'
import { mapState } from 'vuex'
export default {
  components: {
    Banner,
    TypeMenu,
    Research,
    Equipment,
    Quality,
    Production
  },
  data(){
    return{
      banner: {
        img: "/images/locals/keyanbanner.jpg",
        img_loading: "/images/locals_sm/keyanbanner.jpg",
        smallimg: "/images/locals/smallkeyanbanner.jpg",
        smallimg_loading: "/images/locals_sm/smallkeyanbanner.jpg",
        content: {
          cn: "研发实力",
          en: "R & D strength"
        }
      },
      type: [
        {
          ID: '1',
          CALLED: i18n.t('nav.research.submenu.Production'),
          component: 'Production'
        },
        {
          ID: '2',
          CALLED: i18n.t('nav.research.submenu.research'),
          component: 'Research'
        },
        {
          ID: '3',
          CALLED: i18n.t('nav.research.submenu.Quality'),
          component: 'Quality'
        },
        {
          ID: '4',
          CALLED: i18n.t('nav.research.submenu.Equipment'),
          component: 'Equipment'
        }
      ]
    }
  },
  computed: {
    ...mapState({
      lang: state => state.lang
    }),
    component(){
      let index=parseInt(this.$route.params.tid)-1;
      return this.type[index].component
    }
  },
  mounted(){
    Scrollbar.initAll();
  },
  watch: {
    lang: 'settype'
  },
  methods: {
    settype(){
      this.type[0].CALLED=i18n.t('nav.research.submenu.Production')
      this.type[1].CALLED=i18n.t('nav.research.submenu.research')
      this.type[2].CALLED=i18n.t('nav.research.submenu.Quality')
      this.type[3].CALLED=i18n.t('nav.research.submenu.Equipment')
    }
  }
}
</script>

<style scoped>
.keyan .type{
  margin-top: 50px;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .6s ease;
}
.fade-enter, .fade-leave-to
/* .component-fade-leave-active for below version 2.1.8 */ {
  opacity: 0;
}
</style>


